import { useState } from 'react';
import CcfOutboundTrigger, { ITriggerResponse } from '../ccf-outbound-trigger/ccf-outbound-trigger';
import { triggerTypes } from '../ccf-outbound-trigger/ccf-outbound-trigger-helper';
import { CcfOutboundAssignmentIcon } from '@nice-ccf/ui-controls';
import {updateAppSpaceTab} from '@nice-ccf/ui-components';
import styles from "./ccf-outbound-options.module.scss";
import { Contact } from '../ccf-inbox/model/contact';
import { AgentAssistStatus, contactButtons, MediaType, VoiceAuthenticationStatus, VoiceContactStatus } from '@nice-ccf/core-sdk';
import { useDispatch } from 'react-redux';
import { useSimulatorToInsertContact } from '../ccf-inbox/ccf-inbox.slice';
import { AppSpace } from '../../enums/app-space-tabs';

interface ICcfOutboundOptionsProps {
    number: string | number;
    skills?: string[];
    contact?: Contact;
    selectCallType: (trigger: boolean) => void;
}

/**
 * Component to get outbound options
 * @param props - ICcfOutboundOptionsProps
 * @example <CcfOutboundOptions />
 * @returns 
 */
export const CcfOutboundOptions = (props: ICcfOutboundOptionsProps) => {
    const dispatch = useDispatch();
    const [trigger, setTrigger] = useState<boolean>(false);
    const [triggerType, setTriggerType] = useState<string>('');

    /**
     * Function to handle trigger for outbound  
     * @param triggerValue - boolean
     * @param triggerType - string
     * @example - handleTrigger(true, triggerType.type)
     */
    const handleTrigger = (triggerValue: boolean, triggerType?: string) => {
        if (skills.length > 1 && (triggerType || !triggerValue)) {
            setTrigger(triggerValue);
            setTriggerType(triggerType || '');
            props.selectCallType(triggerValue)
        } else if (triggerValue) {
            const tempPayload: Contact ={
              id: '845932153',
              active: true,
              isOutboundCall: true,
              customerChatReply:"",
              customer: {
                accountNumber: '879878686',
                ssn: '123-45-6789',
                firstName: 'Unknown',
                lastName: '',
                customerPrimaryAddress: '1234 Super Long Name Ct. Auburn, CA, 95602',
                phoneNo: props.number?.toString(),
                emailId: 'DavisBRLiam342@sunsyst.com',
                twitterId: '@LiamDavis',
                filteredHistoryCount: 7,
                customerHistory: [],
              },
              "messageType": props.number?.toString(),
              "queueName": "",
              "media": MediaType.VOICE,
              "contactStatus": VoiceContactStatus.ACTIVE,
              "rtaStatus": VoiceAuthenticationStatus.AUTHENTICATED,
              "agentAssistStatus": AgentAssistStatus.NEGATIVE,
              "contactButtons": [contactButtons.hold,contactButtons.transfer, contactButtons.mute, contactButtons.mask, contactButtons.record, contactButtons.keypad, contactButtons.commit, contactButtons.hungup],
            }
                     // eslint-disable-next-line react-hooks/rules-of-hooks
            dispatch(useSimulatorToInsertContact(tempPayload))
            dispatch(updateAppSpaceTab({ tab : AppSpace.CUSTOMERCARD})); 
          }
            // call useSimulatorToInsertContact function in ccf-inbox.slice.ts to initiate call and add card in assignment section 
    };

    const { contact, skills = [] } = props;

    return (
        <div className={styles.outboundOptionsContainer}>
            {
                !trigger &&
                <>
                <span className={styles.textContainer}> 
                    <span className={styles.text}> Outbound Options </span>
                    <hr className={styles.liner} />
                </span>
                {
                    Object.values(triggerTypes).map(triggerType => 
                        <div className={`${styles.outboundOption} ${skills?.length > 1 ? styles.noTriggerButton : '' }`} key={triggerType.id} 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTrigger(true, triggerType.type)
                              }}>
                            <div className={styles.flexDisplay}>
                              <div className={styles.outboundOptionIcon}><triggerType.icon className={styles[triggerType.type]}/></div>
                              <div className={styles.outboundOptionText}>{triggerType.label}</div>
                            </div>
                            <div className={styles.flexDisplay}>
                              { 
                              skills?.length < 2 &&
                                  <CcfOutboundAssignmentIcon className={styles.triggerButton} viewBox="0 0 24 24" onClick={(e) => {
                                    e.stopPropagation();
                                    handleTrigger(true, triggerType.type)
                                  }}></CcfOutboundAssignmentIcon>
                              }
                            </div>
                        </div>
                    )
                }
                </>
            }
            { 
                trigger && skills.length > 1 &&
                // contact &&
                <CcfOutboundTrigger
                    type={triggerType}
                    number={props.number}
                    onTrigger={(res: ITriggerResponse) => handleTrigger(res.trigger)}
                    skills={{values: skills}}
                />
            }
        </div>
    )
}

export default CcfOutboundOptions;
